import { useState, useEffect } from "react";
import cn from "clsx";
import { observer } from "mobx-react";
import styles from "./index.module.scss";
// 组件
import CDNImage from "@/components/cdnImage/cdnImage";

import { tagListVo } from "@/app/csr-src/apis/order/order.interface";

interface productTagProps {
  tagList: tagListVo[];
}

const productTag: React.FC<productTagProps> = observer(({ tagList }) => {
  if (!tagList?.length) {
    return null;
  }

  return tagList.map((item, index) => {
    return (
      <div key={index} className={styles.tagWrap} style={{ background: item.bgColor }}>
        {item.icon ? (
          <div className={styles.tagIco}>
            <CDNImage src={item.icon || ""} width={20} height={20} alt="product_img" style={{ objectFit: "contain", display: "block" }} />
          </div>
        ) : null}
        <div style={{ color: item.textColor }}>{item.text}</div>
      </div>
    );
  });
});

export default productTag;
